export const LOCK_SECTION_MODAL_LOCK_MESSAGE = (section: string): string =>
  `Are you sure you want to lock the ${section} section?`;

export const LOCK_SECTION_MODAL_UNLOCK_MESSAGE =
  'Unlocking this section will reset all Tax calculations, and you will need to complete the Taxes process again.\n\n' +
  'This action will reopen the section for editing.\n\n' +
  'Do you want to proceed?';
